"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_GET_SMS_RECIBIDOS_COLUMNS_MAP = void 0;
exports.SORTABLE_GET_SMS_RECIBIDOS_COLUMNS_MAP = {
    id: 'id',
    origen: 'sender',
    destino: 'receiver',
    enviado: 'senttime',
    recibido: 'receivedtime',
    mensaje: 'msg',
};
